import { render } from "./RemoteAudioAnimation.vue?vue&type=template&id=4e7d2b3e"
import script from "./RemoteAudioAnimation.vue?vue&type=script&lang=ts"
export * from "./RemoteAudioAnimation.vue?vue&type=script&lang=ts"

import "./RemoteAudioAnimation.vue?vue&type=style&index=0&id=4e7d2b3e&lang=scss"
script.render = render

export default script